// get subscription
export const GET_SUBSCRIPTION_REQUEST = 'GET_SUBSCRIPTION_REQUEST';
export const GET_SUBSCRIPTION_SUCCESS = 'GET_SUBSCRIPTION_SUCCESS';
export const GET_SUBSCRIPTION_FAIL = 'GET_SUBSCRIPTION_FAIL';

// get subscription plans
export const GET_SUBSCRIPTION_PLANS_REQUEST = 'GET_SUBSCRIPTION_PLANS_REQUEST';
export const GET_SUBSCRIPTION_PLANS_SUCCESS = 'GET_SUBSCRIPTION_PLANS_SUCCESS';
export const GET_SUBSCRIPTION_PLANS_FAIL = 'GET_SUBSCRIPTION_PLANS_FAIL';

// update subscription
export const UPDATE_SUBSCRIPTION_REQUEST = 'UPDATE_SUBSCRIPTION_REQUEST';
export const UPDATE_SUBSCRIPTION_SUCCESS = 'UPDATE_SUBSCRIPTION_SUCCESS';
export const UPDATE_SUBSCRIPTION_FAIL = 'UPDATE_SUBSCRIPTION_FAIL';
export const CLEAR_UPDATE_SUBSCRIPTION_STATES =
  'CLEAR_UPDATE_SUBSCRIPTION_STATES';

// get add ons
export const GET_ADD_ONS_LIST_REQUEST = 'GET_ADD_ONS_LIST_REQUEST';
export const GET_ADD_ONS_LIST_SUCCESS = 'GET_ADD_ONS_LIST_SUCCESS';
export const GET_ADD_ONS_LIST_FAIL = 'GET_ADD_ONS_LIST_FAIL';

// subscribe add ons
export const SUBSCRIBE_ADD_ONS_REQUEST = 'SUBSCRIBE_ADD_ONS_REQUEST';
export const SUBSCRIBE_ADD_ONS_SUCCESS = 'SUBSCRIBE_ADD_ONS_SUCCESS';
export const SUBSCRIBE_ADD_ONS_FAIL = 'SUBSCRIBE_ADD_ONS_FAIL';
export const CLEAR_SUBSCRIBE_ADD_ONS_STATES = 'CLEAR_SUBSCRIBE_ADD_ONS_STATES';

// retry payment
export const RETRY_PAYMENT_REQUEST = 'RETRY_PAYMENT_REQUEST';
export const RETRY_PAYMENT_SUCCESS = 'RETRY_PAYMENT_SUCCESS';
export const RETRY_PAYMENT_FAIL = 'RETRY_PAYMENT_FAIL';
export const CLEAR_RETRY_PAYMENT_STATES = 'CLEAR_RETRY_PAYMENT_STATES';

// unsubscribe plan
export const UNSUBSCRIBE_PLAN_REQUEST = 'UNSUBSCRIBE_PLAN_REQUEST';
export const UNSUBSCRIBE_PLAN_SUCCESS = 'UNSUBSCRIBE_PLAN_SUCCESS';
export const UNSUBSCRIBE_PLAN_FAIL = 'UNSUBSCRIBE_PLAN_FAIL';
export const CLEAR_UNSUBSCRIBE_PLAN_STATES = 'CLEAR_UNSUBSCRIBE_PLAN_STATES';

// end trial
export const END_TRIAL_REQUEST = 'END_TRIAL_REQUEST';
export const END_TRIAL_SUCCESS = 'END_TRIAL_SUCCESS';
export const END_TRIAL_FAIL = 'END_TRIAL_FAIL';
export const CLEAR_END_TRIAL_STATES = 'CLEAR_END_TRIAL_STATES';

// pay invoice
export const PAY_INVOICE_REQUEST = 'PAY_INVOICE_REQUEST';
export const PAY_INVOICE_SUCCESS = 'PAY_INVOICE_SUCCESS';
export const PAY_INVOICE_FAIL = 'PAY_INVOICE_FAIL';
export const CLEAR_PAY_INVOICE_STATES = 'CLEAR_PAY_INVOICE_STATES';

// upgrade plan
export const UPGRADE_PLAN_REQUEST = 'UPGRADE_PLAN_REQUEST';
export const UPGRADE_PLAN_SUCCESS = 'UPGRADE_PLAN_SUCCESS';
export const UPGRADE_PLAN_FAIL = 'UPGRADE_PLAN_FAIL';
export const CLEAR_UPGRADE_PLAN_STATES = 'CLEAR_UPGRADE_PLAN_STATES';
